import {logger} from '@services';

export class Lang {
	public shortCode: string;
	public country: string;
	public language: string;

	constructor(shortCode: string, country: string, language: string) {
		this.shortCode = shortCode;
		this.country = country;
		this.language = language;
	}

	public static shortCodeToLangue(shortCode: string): string {
		switch (shortCode) {
			case 'en':
				return 'english';
			case 'fr':
				return 'français';
			case 'it':
				return 'italiano';
			case 'de':
				return 'deutsch';
			case 'es':
				return 'español';
			default:
				logger.error(shortCode);
				return 'english';
		}
	}

	toFirebase() {
		return {shortCode: this.shortCode, country: this.country, language: this.language};
	}
}
